<template>
  <el-drawer class="search_drawer drawer" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_search" size="100%"
    direction="btt">
    <el-row class="row_head">
      <el-col :span="4">
        <div class="text-center"><i class="el-dialog__close el-icon el-icon-close" id="close_search"
            @click="$emit('toggle_search')"></i></div>
      </el-col>
      <el-col :span="19">
        <el-input :placeholder="$t('drawer.searchmenu.search')" :value="search_value" @input="handleInput" ref="search_input" id="search-input">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <i slot="suffix" class="el-input__icon el-icon-error" @click=" search_value='' "></i>
        </el-input>
      </el-col>
    </el-row>
    <div class="search_result">
      <template v-if="quantitySearch > 0">
        <MenuGroup
          v-for="(category,index) in menu_result"
          :restaurant_uuid="restaurant_uuid"
          :branch_uuid="branch_uuid"
          :key="'category-'+index"
          :category="category"
          :menu_data="category.menus"
          :from_page="'searchPage'"/>
      </template>
      <template v-else>
        <div id="empty_search" class="width-100p text-center">
          <img class="em" src="@/assets/icons/empty_search.png">
          <h2>{{ $t('drawer.searchmenu.title1') }}</h2>
          <h3>{{ $t('drawer.searchmenu.title2') }}</h3>          
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
import MenuGroup from '@/components/menu/MenuGroup'

/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
export default {
  props: {
    restaurant_uuid: {
      default: ''
    },
    branch_uuid: {
      default: ''
    },
    category_data: {
      default: []
    }
    // is_search:{
    //   default: false
    // }
  },
  components: {
    MenuGroup
  },
  data() {
    return {
      is_search: true,
      search_value:"",
      menu_result:[]
    };
  },
  methods: {
    handleInput(evt){
      this.search_value = evt
    }
  },
  computed:{
    quantitySearch () {
      let numbers = this.menu_result.map(item => item.menus.length)
      const result = numbers.reduce((sum,number) => {
        return sum+number
      }, 0)
      return result
    }
  },
  watch:{
    search_value(){
      let data = JSON.parse(JSON.stringify(this.category_data))
      if(this.search_value != ""){
        data = data.map(item => {
          // let menus = item.menus.filter(menu => menu.name.includes(this.search_value))
          let menus = item.menus.filter(menu => menu.name.toLowerCase().includes(this.search_value.toLowerCase()))
          item.menus = menus
          return item
        })
      }
      this.menu_result = data
    },
    is_search(){
      this.$emit('toggle_search');
    }
  },
  created() {
      this.menu_result = JSON.parse(JSON.stringify(this.category_data))
      if(this.search_value != ""){
        return data.map(item => {
          // let menus = item.menus.filter(menu => menu.name.includes(this.search_value))
          let menus = item.menus.filter(menu => menu.name.toLowerCase().includes(this.search_value.toLowerCase()))
          item.menus = menus
          return item
        })
      }
  },
  mounted() {
    this.$nextTick(()=>{
      this.$refs.search_input.focus();
    });
  }
};

</script>




// WEBPACK FOOTER //
// src/components/search/SearchBtn.vue